<script>
	export default {
		onLaunch: function(options) {
			
			this.$auth.getLocalUserInfo()
			this.$store.commit('savePath', options.path); //打开时访问的链接
		},
		onShow: function() {
			console.log('-------------- 小程序显示 --------------')
		},
		onHide: function() {
			console.log('-------------- bye bye --------------')
		},
		
	}
</script>

<style>
	/*每个页面公共css */
	.page {
		box-sizing: border-box;
		width: 100vw;
		height: 100vh;
		background: #efefef;
		overflow: auto;
		color: #100F19;
	}
	checkbox{
		border: #4963F4;
	}
</style>
